import { render, staticRenderFns } from "./index_ins.vue?vue&type=template&id=124ae0ef&scoped=true"
import script from "./index_ins.vue?vue&type=script&lang=js"
export * from "./index_ins.vue?vue&type=script&lang=js"
import style0 from "./index_ins.vue?vue&type=style&index=0&id=124ae0ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ae0ef",
  null
  
)

export default component.exports